/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProviderCredentialListConfiguration
 */
export interface ProviderCredentialListConfiguration {
    /**
     * 
     * @type {Array<GuidIdAndLabel>}
     * @memberof ProviderCredentialListConfiguration
     */
    readonly providers?: Array<GuidIdAndLabel> | null;
    /**
     * 
     * @type {Array<BrandAndMarketListItem>}
     * @memberof ProviderCredentialListConfiguration
     */
    readonly brandsAndMarkets?: Array<BrandAndMarketListItem> | null;
}

export function ProviderCredentialListConfigurationFromJSON(json: any): ProviderCredentialListConfiguration {
    return ProviderCredentialListConfigurationFromJSONTyped(json, false);
}

export function ProviderCredentialListConfigurationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProviderCredentialListConfiguration {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'providers': !exists(json, 'providers') ? undefined : (json['providers'] === null ? null : (json['providers'] as Array<any>).map(GuidIdAndLabelFromJSON)),
        'brandsAndMarkets': !exists(json, 'brandsAndMarkets') ? undefined : (json['brandsAndMarkets'] === null ? null : (json['brandsAndMarkets'] as Array<any>).map(BrandAndMarketListItemFromJSON)),
    };
}

export function ProviderCredentialListConfigurationToJSON(value?: ProviderCredentialListConfiguration | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
    };
}


